import React, {useState, useRef, useEffect} from 'react'

import noImage from 'assets/images/dashboard/noImage.png'
import {Box, Button} from '@mui/material'
import Lightbox from "yet-another-react-lightbox";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import ZoomIcon from 'assets/icons/zoom.svg'

// Protected Video Component
const ProtectedVideo = ({src, sx, frameSx}) => {
    const videoRef = useRef(null);
    
    useEffect(() => {
        const video = videoRef.current;
        if (video) {
            // Disable right-click context menu
            video.addEventListener('contextmenu', (e) => e.preventDefault());
            
            // Disable drag and drop
            video.addEventListener('dragstart', (e) => e.preventDefault());
            
            // Disable keyboard shortcuts that might help download
            video.addEventListener('keydown', (e) => {
                // Disable F12, Ctrl+S, Ctrl+Shift+I, etc.
                if (e.key === 'F12' || 
                    (e.ctrlKey && e.key === 's') ||
                    (e.ctrlKey && e.shiftKey && e.key === 'I') ||
                    (e.ctrlKey && e.key === 'u')) {
                    e.preventDefault();
                }
            });
            
            // Prevent video element from being inspected
            video.addEventListener('loadstart', () => {
                // Remove any download-related attributes
                video.removeAttribute('download');
                video.removeAttribute('controlsList');
            });
        }
    }, []);
    
    return (
        <video 
            ref={videoRef}
            controls
            controlsList="nodownload nofullscreen noremoteplayback"
            disablePictureInPicture
            onContextMenu={(e) => e.preventDefault()}
            onDragStart={(e) => e.preventDefault()}
            onSelectStart={(e) => e.preventDefault()}
            onLoadStart={(e) => {
                // Additional protection on load
                e.target.removeAttribute('download');
            }}
            style={{
                userSelect: 'none',
                WebkitUserSelect: 'none',
                MozUserSelect: 'none',
                msUserSelect: 'none',
                pointerEvents: 'auto',
                ...sx
            }}
            sx={frameSx}
        >
            <source src={src}/>
            Your browser does not support the video tag.
        </video>
    );
};


const ContentFrame = ({children, sx, frameSx, controls}) => {
    return <Box
        sx={{
            height: '10vh', // Changed to full viewport height
            overflow: 'hidden',
            position: 'relative',
            ...frameSx,
            '& img, & video': {
                borderRadius: '10px',
                height: '100%',
                width: '100%',
                ...sx,
                objectFit: 'cover', 
            },
            // Prevent text selection and right-click on the entire frame
            userSelect: 'none',
            WebkitUserSelect: 'none',
            MozUserSelect: 'none',
            msUserSelect: 'none',
            '& *': {
                userSelect: 'none',
                WebkitUserSelect: 'none',
                MozUserSelect: 'none',
                msUserSelect: 'none'
            }
            // '& img , & video' : {
            //     borderRadius: '10px',
            //     height: '100%',
            //     width: {
            //         xs: '100%',
            //         lg: '100%'
            //     },
            //     ...sx
            // }
        }}
        onContextMenu={(e) => e.preventDefault()}
        onDragStart={(e) => e.preventDefault()}
        onSelectStart={(e) => e.preventDefault()}
    >{children}

        </Box>
}
export const RenderContent = ({fileOrStream, sx, frameSx, type}) => {

    const [isOpen, setIsOpen] = useState(false);
    const [image, setImage] = useState();
    const zoomRef = React.useRef(null);
    const handleLightBox = (img) => {
        setImage(img)
        setIsOpen(true)
    }

    const props = {
        sx,
        frameSx
    }
    if (typeof fileOrStream == 'string') {

        const File = fileOrStream.split('/')
        const FileName = File.pop();

        if (FileName.includes('.mp4')) {
            return <ContentFrame {...props}>
                <ProtectedVideo src={fileOrStream} sx={sx} frameSx={frameSx} />
            </ContentFrame>
        } else {
            return <ContentFrame {...props}>

            {type != 'edit' && (
                <Box
                    sx={{
                        display: 'flex',
                        height: '100%',
                        position: 'relative',
                        overflow: 'hidden'
                    }}>

                    <img src={fileOrStream}/>
                    <Button
                        sx={{
                            height:60,
                            width:10,
                            position: 'absolute',
                            bottom: 0,
                            right: 0,
                            margin: '3px',
                    
                        }}  
                        onClick={() => handleLightBox(fileOrStream)}>
                        <img style={{width:25, height:25}} src={ZoomIcon}/>
                    </Button>
                    <Lightbox
                        open={isOpen}
                        plugins={[Fullscreen, zoom]}
                        zoom={{
                            ref: zoomRef
                        }}
                        close={() => setIsOpen(false)}
                        slides={[{
                                src: fileOrStream
                            }
                        ]}/>
                </Box>
            )}
               
            </ContentFrame>
        }
    }

    if (
        fileOrStream?.type.includes('image')
    ) 

        return <ContentFrame {...props}>
             <img src={URL.createObjectURL(fileOrStream)}/>
        </ContentFrame>
    if (
        fileOrStream?.type.includes('video')
    ) 
        return <ContentFrame {...props}>
            <ProtectedVideo src={URL.createObjectURL(fileOrStream) + '#t=0.1'} sx={sx} frameSx={frameSx} />
        </ContentFrame>

    return <ContentFrame><img src={noImage}/></ContentFrame>
}
